import { Link } from "react-router-dom";
import { HeartPulse } from "lucide-react";

export const Logo = ({ light = false, className = "", size = "md" }) => {
  const wm = size === "lg" ? "text-3xl" : "text-[1.55rem]";
  const box = size === "lg" ? "w-14 h-14" : "w-11 h-11";
  const icon = size === "lg" ? "w-8 h-8" : "w-6 h-6";
  return (
    <Link
      to="/"
      data-testid="brand-logo"
      className={`inline-flex items-center gap-2.5 ${className}`}
    >
      <span className={`relative grid place-items-center ${box} rounded-xl bg-brand-navy shadow-md`}>
        <span className="absolute inset-0 rounded-xl ring-1 ring-white/10" />
        <HeartPulse className={`${icon} text-brand-red`} strokeWidth={2.6} />
      </span>
      <span className={`font-display font-extrabold ${wm} leading-none tracking-tight`}>
        <span className={light ? "text-white" : "text-brand-navy"}>Life</span>
        <span className="text-brand-red">Button</span>
        <span className={light ? "text-white/70" : "text-brand-navy"}>.org</span>
      </span>
    </Link>
  );
};
